import $ from 'jquery'
import { setCurrency } from '../helpers'
import Choices from 'choices.js'

class Colo {
  constructor() {
    this.orderForm = $('.gf-colo')

    if (!this.orderForm.length) return

    this.isEuForm = this.orderForm.hasClass('gf-colo--eu')

    this.init()
    this.events()
  }

  init() {

    const selects = document.querySelectorAll('.gf-colo__imagable-select')

    selects.forEach(el => {
      new Choices(el.querySelector('select'), {
        searchEnabled: false,
        shouldSort: false,
        callbackOnCreateTemplates: function (
          template, escapeForTemplate, getClassNames) {

          function getImage(data) {
            let images = data.element.closest('.gf-colo__imagable-select').
              querySelector('.gfield_description').textContent
            const imageObj = images ? JSON.parse(images) : ''
            return imageObj[data.id - 1] ? `<img src="${imageObj[data.id -
            1]}" alt="${data.value}" />` : ''
          }

          function getSpanValue(item) {
            return `${item.element.closest('.gfield_select').getAttribute('id')}-${item.value}`
          }

          return {
            item: ({ classNames }, data) => {
              const image = getImage(data)

              const dataSpan = getSpanValue(data)

              return template(`
          <div class="gf-colo__imagable-option ${getClassNames(classNames.item).
                join(' ')} ${
                getClassNames(data.highlighted
                  ? classNames.highlightedState
                  : classNames.itemSelectable).join(' ')
              } ${
                data.placeholder ? classNames.placeholder : ''
              }" data-item data-id="${data.id}" data-value="${data.value}" ${
                data.active ? 'aria-selected="true"' : ''
              } ${data.disabled ? 'aria-disabled="true"' : ''}>
            ${image}
            <span data-item-span="${dataSpan}">${data.label}</span>
          </div>
        `)
            },
            choice: ({ classNames }, data) => {
              const image = getImage(data)
              const dataSpan = getSpanValue(data)
              return template(`
          <div class="gf-colo__imagable-option ${getClassNames(classNames.item).
                join(' ')} ${getClassNames(classNames.itemChoice).join(' ')} ${
                getClassNames(data.disabled
                  ? classNames.itemDisabled
                  : classNames.itemSelectable).join(' ')
              }" data-choice ${
                data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : 'data-choice-selectable'
              } data-id="${data.id}" data-value="${escapeForTemplate(
                data.value)}" ${
                data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
              }>
            ${image}
            <span data-choice-span="${dataSpan}">${data.label}</span>
          </div>
        `)
            },
          }
        },
      })
    })

  }

  events() {
    gform.addAction('gform_input_change', this.createOrder.bind(this))
  }

  calcPriceRUB() {

    const properties = this.orderForm.find('option')

    const isCurrencyRub = $('.gf-colo__currency input').is(':checked')

    const currency = setCurrency(isCurrencyRub)

    const imageOptions = document.querySelectorAll('.gf-colo__imagable-option')
    // Все цены
    properties.filter((id, item) => {
      let price = +item.value

      const label = item.textContent.split('—')

      if (isCurrencyRub) {
        price = Math.round(price * ATLEX_OBJ.exchange_rate.eur)
      }

      const value = price > 0 ? `— ${price} ${currency}` : ''

      item.textContent = `${label[0]} ${value}`

      const isImagable = item.closest('.gf-colo__imagable-select')
      if (isImagable) {
        const dataSpan = `${item.closest('.gfield_select').getAttribute('id')}-${item.value}`
        $(`[data-item-span="${dataSpan}"]`).text(`${label[0]} ${value}`)
        $(`[data-choice-span="${dataSpan}"]`).text(`${label[0]} ${value}`)

      }
    })
  }

  calcTotalPriceRUB() {

    const totalPriceFiled = $('.gf-colo__total-price')
    const totalPriceInput = totalPriceFiled.find('input')
    const totalPriceText = totalPriceFiled.find('.gfield_description')

    const isCurrencyRub = $('.gf-colo__currency input').is(':checked')
    const currency = setCurrency(isCurrencyRub)

    let price = +totalPriceInput.val().replace(/[\s,]/g, '')

    if (isCurrencyRub) {
      price = Math.round(price * ATLEX_OBJ.exchange_rate.eur).
        toLocaleString('ru-RU')
    } else {
      price = price.toLocaleString('en-GB')
    }

    totalPriceText.text(price + ' ' + currency)

  }

  setGAPrice() {
    const totalPrice = +$('.gf-colo__total-price input').val().replace(' ', '')
    const gaTotalPriceField = $('.gf-colo__ga-total-price input')
    gaTotalPriceField.val(totalPrice)
  }

  createOrder(elem, formId, fieldId) {

    if (this.isEuForm) {
      this.calcPriceRUB()
      this.calcTotalPriceRUB()
    }

    this.setGAPrice()

  }
}

export default Colo
